import { jsx as t } from "react/jsx-runtime";
import l from "clsx";
import n from "./SvgIcon.module.css.js";
const v = ["currentColor", "inherit"], d = {
  color: "inherit",
  fill: "currentColor",
  stroke: void 0
}, m = (r, o) => o && !v.includes(o) ? o : d[r], u = ({
  color: r = "inherit",
  size: o = "inherit",
  ariaLabel: e = void 0,
  children: i,
  className: s,
  ...c
}) => /* @__PURE__ */ t(
  "svg",
  {
    className: l(n.svgIcon, s),
    style: {
      "--louis-svgicon-color": m("color", r),
      "--louis-svgicon-size": o
    },
    ...c,
    "aria-hidden": e ? void 0 : !0,
    role: e ? "img" : void 0,
    "aria-label": e,
    viewBox: "0 0 20 20",
    children: i
  }
);
export {
  u as SvgIcon
};
//# sourceMappingURL=SvgIcon.js.map
